<template>
    <div class="main_holder">
        <div class="content_holder">
            <div class="content">
                <h2>Pogosta vprašanja</h2>

                <div v-if="getUserType == 2" class="faq_texteditor_content">
                    <TextEditor class="full_width" v-model="editor" />
                    <button class="button" @click="send()">Shrani</button>
                </div>

                <div class="faq_text_content">
                    <span v-html="faqText"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TextEditor from "@/components/general/TextEditor.vue";

export default {
    name: "faq",
    components: { TextEditor },
    props: {
        tab: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            editor: "",
        };
    },
    computed: {
        getUserType() {
            return this.$store.state.user.type;
        },
        ...mapGetters(["faq_text"]),
        faqText() {
            return this.faq_text;
        },
    },
    watch: {
        faq_text: {
            handler(val) {
                this.editor = val;
            },
            immediate: true, // sync on initial mount too
        },
    },
    methods: {
        ...mapActions(["sendFaq", "getFaq"]),
        send() {
            this.sendFaq({ text: this.editor, tab: this.tab });
        },
    },
    created() {
        this.getFaq({ tab: this.tab });
    },
};
</script>


<style lang="scss" scoped></style>
